import React, { useEffect, useState } from "react";
import { message } from "antd";
import ChangePaymentStatus from "./ChangePaymentStatus";
import { requestListActions } from "../../../../../../request-list.actions";
import { useDispatch } from "react-redux";
import { checkSameStatus } from "./constants";

const CheckingPaymentStatuses = ({ requests, onSuccess }) => {
  const [isSameStatus, setIsSameStatus] = useState(true);

  const commonProps = { requests, onSuccess };

  const dispatch = useDispatch();

  useEffect(() => {
    
    const sameStatus = checkSameStatus(requests);
    setIsSameStatus(sameStatus);

    if (!sameStatus) {
      message.error("Выбранные заявки должны принадлежать одному статусу оплаты");
      dispatch(requestListActions.setSelected([]));
    }
  }, [requests]);

  return isSameStatus ? <ChangePaymentStatus {...commonProps} /> : null;
};

export default CheckingPaymentStatuses;
